<div class="message-container blue-fill mb-3">
  @if (displayMemberSSNForm) {
    <div>
      <mwp-text-translate text="Your Social Security Number is required in order to proceed with this Checkout Process. Please provide a valid SSN below" jsonKey="ssnPleaseProvide" />
    </div>
  }
  @if (!displayMemberSSNForm) {
    <div>
      <mwp-text-translate text="The following members are either enrolled or requested to be enrolled in one or more benefits that require your employer to obtain, or attempt to obtain, valid social security numbers for federal reporting and claims processing purposes" jsonKey="ssnTheFollowingMembers" />
    </div>
  }
</div>

@if (displayMemberSSNForm) {
  <div class="content-container form-comp mb-3">
    <div class="content">
      <form [formGroup]="memberFrom" class="d-inline-flex">
        <div>
          {{ memberName }}
        </div>
        <div class="ms-2">
          <mwp-input [form]="memberFrom" labelName="SSN" nameForControl="sSN" [maskType]="maskType.social" autoComplete="off" />
        </div>
      </form>
    </div>
    <div class="footer">
      <button class="mwp-button-save ms-3" [disabled]="memberFrom.invalid" (click)="saveMemberSSN()">
        <mwp-text-translate text="Save Member SSN" jsonKey="ssnSaveMember" />
      </button>
    </div>
  </div>
}

@if (!displayMemberSSNForm) {
  <div class="content-container table-comp mb-3">
    <div class="content">
      <div class="p-3">
        <div class="message-container blue-fill">
          @if (!spouseSSNRequiredMessage) {
            <span>
              <mwp-text-translate text="SSN's for spouse and dependent children are not required but highly encouraged to expedite claims processing and legislative reporting processes." jsonKey="ssnSpouseSSNRequiredMessage" />
            </span>
          }
          @if (spouseSSNRequiredMessage) {
            <span>
                    <mwp-text-translate text="SSN's for a spouse is required to be provided. SSN's for dependent children are not required but highly encouraged to
                        expedite claims processing and legislative reporting processes" jsonKey="ssnSpouseSSNRequiredMessage" />
              </span>
            }
          </div>
        </div>
        <div class="p-3">
          <mwp-text-translate text="Please provide valid SSN's for the members listed." jsonKey="ssnPleaseProvide" />
        </div>
        @if (dependentForm) {
          <div>
            <mwp-table-formarray [form]="dependentForm" [arrayName]="depedentFormArrayName" [tableColumns]="depedentTableColumns" [dataSource]="depedentMatTableData" />
          </div>
        }
      </div>
    </div>
  }

  <div>
    <mwp-benefit-enrollment-wizard-control [isCheckout]="true" [isContinueDisabled]="dependentForm.invalid" (emitComplete)="complete()" />
  </div>